import dayjs from "dayjs";

export const initialValues = {
  paymentDestination: 0,
  concept: "",
  amount: "",
  email: "",
  validity: dayjs().add(1, "day"),
  reference: "",
};
